"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var md5 = function md5(value) {
  var rotateLeft = function rotateLeft(number, count) {
    return number << count | number >>> 32 - count;
  };
  var addUnsigned = function addUnsigned(left, right) {
    var leftHigh = left & 0x80000000;
    var rightHigh = right & 0x80000000;
    var leftLow = left & 0x40000000;
    var rightLow = right & 0x40000000;
    var result = (left & 0x3FFFFFFF) + (right & 0x3FFFFFFF);
    if (leftLow & rightLow) return result ^ 0x80000000 ^ leftHigh ^ rightHigh;
    if (leftLow | rightLow) {
      if (result & 0x40000000) return result ^ 0xC0000000 ^ leftHigh ^ rightHigh;
      return result ^ 0x40000000 ^ leftHigh ^ rightHigh;
    }
    return result ^ leftHigh ^ rightHigh;
  };
  var f = function f(x, y, z) {
    return x & y | ~x & z;
  };
  var g = function g(x, y, z) {
    return x & z | y & ~z;
  };
  var h = function h(x, y, z) {
    return x ^ y ^ z;
  };
  var i = function i(x, y, z) {
    return y ^ (x | ~z);
  };
  var transform = function transform(fn, a, b, c, d, x, s, ac) {
    return addUnsigned(rotateLeft(addUnsigned(addUnsigned(a, fn(b, c, d)), addUnsigned(x, ac)), s), b);
  };
  var toWords = function toWords(input) {
    var length = input.length;
    var wordCount = ((length + 8 - (length + 8) % 64) / 64 + 1) * 16;
    var words = new Array(wordCount - 1);
    var bytePosition = 0;
    for (var byteCount = 0; byteCount < length; byteCount++) {
      var _wordIndex = (byteCount - byteCount % 4) / 4;
      bytePosition = byteCount % 4 * 8;
      words[_wordIndex] = (words[_wordIndex] || 0) | input.charCodeAt(byteCount) << bytePosition;
    }
    var wordIndex = (length - length % 4) / 4;
    bytePosition = length % 4 * 8;
    words[wordIndex] = (words[wordIndex] || 0) | 0x80 << bytePosition;
    words[wordCount - 2] = length << 3;
    words[wordCount - 1] = length >>> 29;
    return words;
  };
  var toHex = function toHex(number) {
    var output = '';
    for (var count = 0; count <= 3; count++) {
      var _value = number >>> count * 8 & 255;
      output += "0".concat(_value.toString(16)).slice(-2);
    }
    return output;
  };
  var input = unescape(encodeURIComponent(value));
  var words = toWords(input);
  var a = 0x67452301;
  var b = 0xEFCDAB89;
  var c = 0x98BADCFE;
  var d = 0x10325476;
  for (var k = 0; k < words.length; k += 16) {
    var aa = a;
    var bb = b;
    var cc = c;
    var dd = d;
    a = transform(f, a, b, c, d, words[k], 7, 0xD76AA478);
    d = transform(f, d, a, b, c, words[k + 1], 12, 0xE8C7B756);
    c = transform(f, c, d, a, b, words[k + 2], 17, 0x242070DB);
    b = transform(f, b, c, d, a, words[k + 3], 22, 0xC1BDCEEE);
    a = transform(f, a, b, c, d, words[k + 4], 7, 0xF57C0FAF);
    d = transform(f, d, a, b, c, words[k + 5], 12, 0x4787C62A);
    c = transform(f, c, d, a, b, words[k + 6], 17, 0xA8304613);
    b = transform(f, b, c, d, a, words[k + 7], 22, 0xFD469501);
    a = transform(f, a, b, c, d, words[k + 8], 7, 0x698098D8);
    d = transform(f, d, a, b, c, words[k + 9], 12, 0x8B44F7AF);
    c = transform(f, c, d, a, b, words[k + 10], 17, 0xFFFF5BB1);
    b = transform(f, b, c, d, a, words[k + 11], 22, 0x895CD7BE);
    a = transform(f, a, b, c, d, words[k + 12], 7, 0x6B901122);
    d = transform(f, d, a, b, c, words[k + 13], 12, 0xFD987193);
    c = transform(f, c, d, a, b, words[k + 14], 17, 0xA679438E);
    b = transform(f, b, c, d, a, words[k + 15], 22, 0x49B40821);
    a = transform(g, a, b, c, d, words[k + 1], 5, 0xF61E2562);
    d = transform(g, d, a, b, c, words[k + 6], 9, 0xC040B340);
    c = transform(g, c, d, a, b, words[k + 11], 14, 0x265E5A51);
    b = transform(g, b, c, d, a, words[k], 20, 0xE9B6C7AA);
    a = transform(g, a, b, c, d, words[k + 5], 5, 0xD62F105D);
    d = transform(g, d, a, b, c, words[k + 10], 9, 0x02441453);
    c = transform(g, c, d, a, b, words[k + 15], 14, 0xD8A1E681);
    b = transform(g, b, c, d, a, words[k + 4], 20, 0xE7D3FBC8);
    a = transform(g, a, b, c, d, words[k + 9], 5, 0x21E1CDE6);
    d = transform(g, d, a, b, c, words[k + 14], 9, 0xC33707D6);
    c = transform(g, c, d, a, b, words[k + 3], 14, 0xF4D50D87);
    b = transform(g, b, c, d, a, words[k + 8], 20, 0x455A14ED);
    a = transform(g, a, b, c, d, words[k + 13], 5, 0xA9E3E905);
    d = transform(g, d, a, b, c, words[k + 2], 9, 0xFCEFA3F8);
    c = transform(g, c, d, a, b, words[k + 7], 14, 0x676F02D9);
    b = transform(g, b, c, d, a, words[k + 12], 20, 0x8D2A4C8A);
    a = transform(h, a, b, c, d, words[k + 5], 4, 0xFFFA3942);
    d = transform(h, d, a, b, c, words[k + 8], 11, 0x8771F681);
    c = transform(h, c, d, a, b, words[k + 11], 16, 0x6D9D6122);
    b = transform(h, b, c, d, a, words[k + 14], 23, 0xFDE5380C);
    a = transform(h, a, b, c, d, words[k + 1], 4, 0xA4BEEA44);
    d = transform(h, d, a, b, c, words[k + 4], 11, 0x4BDECFA9);
    c = transform(h, c, d, a, b, words[k + 7], 16, 0xF6BB4B60);
    b = transform(h, b, c, d, a, words[k + 10], 23, 0xBEBFBC70);
    a = transform(h, a, b, c, d, words[k + 13], 4, 0x289B7EC6);
    d = transform(h, d, a, b, c, words[k], 11, 0xEAA127FA);
    c = transform(h, c, d, a, b, words[k + 3], 16, 0xD4EF3085);
    b = transform(h, b, c, d, a, words[k + 6], 23, 0x04881D05);
    a = transform(h, a, b, c, d, words[k + 9], 4, 0xD9D4D039);
    d = transform(h, d, a, b, c, words[k + 12], 11, 0xE6DB99E5);
    c = transform(h, c, d, a, b, words[k + 15], 16, 0x1FA27CF8);
    b = transform(h, b, c, d, a, words[k + 2], 23, 0xC4AC5665);
    a = transform(i, a, b, c, d, words[k], 6, 0xF4292244);
    d = transform(i, d, a, b, c, words[k + 7], 10, 0x432AFF97);
    c = transform(i, c, d, a, b, words[k + 14], 15, 0xAB9423A7);
    b = transform(i, b, c, d, a, words[k + 5], 21, 0xFC93A039);
    a = transform(i, a, b, c, d, words[k + 12], 6, 0x655B59C3);
    d = transform(i, d, a, b, c, words[k + 3], 10, 0x8F0CCC92);
    c = transform(i, c, d, a, b, words[k + 10], 15, 0xFFEFF47D);
    b = transform(i, b, c, d, a, words[k + 1], 21, 0x85845DD1);
    a = transform(i, a, b, c, d, words[k + 8], 6, 0x6FA87E4F);
    d = transform(i, d, a, b, c, words[k + 15], 10, 0xFE2CE6E0);
    c = transform(i, c, d, a, b, words[k + 6], 15, 0xA3014314);
    b = transform(i, b, c, d, a, words[k + 13], 21, 0x4E0811A1);
    a = transform(i, a, b, c, d, words[k + 4], 6, 0xF7537E82);
    d = transform(i, d, a, b, c, words[k + 11], 10, 0xBD3AF235);
    c = transform(i, c, d, a, b, words[k + 2], 15, 0x2AD7D2BB);
    b = transform(i, b, c, d, a, words[k + 9], 21, 0xEB86D391);
    a = addUnsigned(a, aa);
    b = addUnsigned(b, bb);
    c = addUnsigned(c, cc);
    d = addUnsigned(d, dd);
  }
  return "".concat(toHex(a)).concat(toHex(b)).concat(toHex(c)).concat(toHex(d)).toLowerCase();
};
var _default = exports.default = {
  name: 'CodecTools',
  bodyClass: 'codec-tools-page',
  data: function data() {
    return {
      activeTab: 'text',
      imageError: '',
      imageInput: '',
      imagePreview: '',
      textError: '',
      textInput: '',
      textOutput: ''
    };
  },
  methods: {
    goBack: function goBack() {
      this.$router.back();
    },
    encodeBase64: function encodeBase64() {
      this.textError = '';
      try {
        this.textOutput = btoa(unescape(encodeURIComponent(this.textInput)));
      } catch (error) {
        this.textOutput = '';
        this.textError = 'Nao foi possivel converter o texto para Base64.';
      }
    },
    decodeBase64: function decodeBase64() {
      this.textError = '';
      try {
        var normalizedInput = this.textInput.replace(/^data:[^,]+,/, '').trim();
        this.textOutput = decodeURIComponent(escape(atob(normalizedInput)));
      } catch (error) {
        this.textOutput = '';
        this.textError = 'Conteudo Base64 invalido para texto.';
      }
    },
    generateSha256: function () {
      var _generateSha = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var buffer;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.textError = '';
              if (!(!window.crypto || !window.crypto.subtle)) {
                _context.n = 1;
                break;
              }
              this.textOutput = '';
              this.textError = 'SHA-256 nao esta disponivel neste navegador.';
              return _context.a(2);
            case 1:
              _context.n = 2;
              return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(this.textInput));
            case 2:
              buffer = _context.v;
              this.textOutput = Array.from(new Uint8Array(buffer)).map(function (byte) {
                return byte.toString(16).padStart(2, '0');
              }).join('');
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function generateSha256() {
        return _generateSha.apply(this, arguments);
      }
      return generateSha256;
    }(),
    generateMd5: function generateMd5() {
      this.textError = '';
      this.textOutput = md5(this.textInput);
    },
    clearText: function clearText() {
      this.textError = '';
      this.textInput = '';
      this.textOutput = '';
    },
    decodeImage: function decodeImage() {
      this.imageError = '';
      var content = this.imageInput.trim();
      if (!content) {
        this.imagePreview = '';
        return;
      }
      this.imagePreview = content.startsWith('data:image/') ? content : "data:image/*;base64,".concat(content.replace(/^data:[^,]+,/, ''));
    },
    handleImageError: function handleImageError() {
      this.imagePreview = '';
      this.imageError = 'Conteudo Base64 invalido para imagem.';
    },
    clearImage: function clearImage() {
      this.imageError = '';
      this.imageInput = '';
      this.imagePreview = '';
    }
  }
};